import { Component, useState } from "react";
import { useTranslation } from "react-i18next";
import Page from "../../layout/Page";
import { DataTable } from "../../components/DataTable";
import ListPageActions from "../../components/ListPageActions";
import DownloadButton from "../../components/DownloadButton";
import CustButton from "../../ui/CustButton";
import DateFilterCell from "../../components/DateFilterCell";
import usePaginationV2 from "../../util/usePaginationV2";
import { parseAndFormatDate, parseAndFormatDateTime } from "../../util/DateUtil";
import FilterOptionEnum from "../../enum/FilterOptionEnum";
import { Delete, WrapText } from "@mui/icons-material";
import HangfireLoglamaservice from "../../service/MasterServices/HangfireLoglamaService";
import ProccessStatus from "../../enum/ProccessStatus";
import FixedWidthText from "../../ui/FixedWidthText";
import DynamicOptions from "../../components/DynamicOptions";
import DialogConfirm from "../../components/DialogConfirm";
import { IconButton } from "@mui/material";
import { useSelector } from "react-redux";

const HangfireLoglamaPage = ({ title }) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false); // Loading state for action handling
    const [isTruncated, setIsTruncated] = useState(true);
    const [deleteItem, setDeleteItem] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);

    const { user } = useSelector(state => state.auth);

    // Toggle between truncated and full text
    const handleToggle = () => {
        setIsTruncated(prevState => !prevState);
    };

    // Handle confirm dialog open/close
    const openConfirmDialog = (item) => {
        // setActionType(item);
        setDeleteItem(item);
        setOpenDialog(true);
    };

    // Handle delete actions
    const handleDeleteAction = async () => {
        if (!deleteItem) return;

        setLoading(true);  // Start loading
        try {
            const result = await HangfireLoglamaservice.delete(deleteItem.id);

            if (result) {
                mainDataList.search();  // Refresh data after success
            }
        } catch (error) {
            console.error("Action failed:", error); // Handle any error that occurs during the action
            // Optionally, display an error notification or message
        } finally {
            setLoading(false);  // End loading regardless of success or failure
            setOpenDialog(false);  // Close the confirm dialog
        }
    };
    const closeConfirmDialog = () => setOpenDialog(false);

    // Column definitions
    const columns = [
        user.isMaster == true ? {
            name: "tenantName",
            label: t('label.tenantName'),
            textAlign: "left",
            searchable: true,
            selectOptions: <DynamicOptions serviceType="Tenant" />,
            searchType: 'select',
            searchField: "tenantId",
            orderByField: "tenantName",
        } : {
            name: "tenantName",
            label: t('label.tenantName'),
            textAlign: "left",
            searchable: false,
        },
        {
            name: "operationName",
            label: t('label.operationName'),
            textAlign: "left",
            selectOptions: <DynamicOptions serviceType="BatchOperation" />,
            searchType: 'select',
            searchField: "operationId",
            orderByField: "operationName",
        },
        {
            name: "runningDate",
            label: t('label.runningDate'),
            textAlign: "center",
            execute: (item) => parseAndFormatDate(item),
            searchable: true,
            searchType: "custom",
            searchComponent: DateFilterCell
        },
        {
            name: "startTime",
            label: t('label.startTime'),
            textAlign: "center",
            execute: (item) => parseAndFormatDateTime(item),
            searchable: true,
            searchType: "custom",
            searchComponent: DateFilterCell
        },
        {
            name: "endTime",
            label: t('label.endTime'),
            textAlign: "center",
            execute: (item) => parseAndFormatDateTime(item),
            searchable: true,
            searchType: "custom",
            searchComponent: DateFilterCell
        },


        {
            name: "status",
            label: t('label.status'),
            textAlign: "center",
            execute: (item) => ProccessStatus[item],
            searchable: true,
            searchType: "select",
            selectOptions: <FilterOptionEnum enumObject={ProccessStatus} />
        },
        {
            name: "exception",
            label: t('label.exception'),
            textAlign: "center",
            execute: (item =>

                <FixedWidthText
                    text={`${item ?? ""}`}
                    maxLength={-1}
                    truncated={isTruncated}
                />


            ),
        },
        {
            sortable: false,
            searchable: false,
            passItem: true,
            textAlign: "Center",
            title: "action",
            execute: (item) => (
                <>
                    <IconButton
                        onClick={() => openConfirmDialog(item)}
                        color="error"
                        variant="contained"
                        title={t("rowActions.delete")}
                        size="small">
                        <Delete />
                    </IconButton>
                </>
            ),
        },
    ];

    // Pagination configuration
    const mainDataList = usePaginationV2({
        service: HangfireLoglamaservice,
        defaultSearchData: { isMaster: user.isMaster },
        pageColumns: columns,
        defaultOrderBy: { name: "Id", type: "Desc" },
    });

    // Action buttons component
    const ActionButtons = () => (
        <ListPageActions
            right={
                <>
                    <CustButton
                        icon={WrapText}
                        onClick={() => handleToggle()}
                        style={{ marginLeft: 10 }}
                        disabled={loading}  // Disable buttons when loading
                    ></CustButton>
                </>
            }
        >
            <DownloadButton service={mainDataList} disabled={loading} />
        </ListPageActions>
    );

    return (
        <Page title={t(title)}>
            <ActionButtons />

            <DataTable
                columns={columns}
                {...mainDataList}
                loading={loading}  // Pass loading state to DataTable if applicable
            />

            <DialogConfirm
                open={openDialog}
                title={t('title.confirmDialogTitle')}
                content={t('message.areYouSureAction')}
                onClose={closeConfirmDialog}
                //onConfirm={handleAction}
                onConfirm={handleDeleteAction}
                loading={loading}  // Disable confirm button when loading
            />


        </Page>
    );
};

export default HangfireLoglamaPage;
